import { render, staticRenderFns } from "./addHelpdesk.vue?vue&type=template&id=c6ddcdd8&scoped=true&"
import script from "./addHelpdesk.vue?vue&type=script&lang=js&"
export * from "./addHelpdesk.vue?vue&type=script&lang=js&"
import style0 from "./addHelpdesk.vue?vue&type=style&index=0&id=c6ddcdd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6ddcdd8",
  null
  
)

export default component.exports